import { jsx } from "react/jsx-runtime";
import Markers from "../Markers/Markers.js";
import classnames from "../../utils/classnames.js";
import './CarTile.css';/* empty css             */
const CarTileMarkers = ({ className, ...props }) => /* @__PURE__ */ jsx(Markers, { className: classnames("perxis-auto-car-tile-markers", className), ...props });
export {
  CarTileMarkers as default
};
//# sourceMappingURL=CarTileMarkers.js.map
